// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pilcrow.js';

import { paths } from '../generated/pilcrow';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pilcrow', Original, paths);
